import { createContext, useContext, useState, useCallback } from "react";
import { Navigate } from "react-router-dom";

const AuthContext = createContext(null);

const STORAGE_KEY = "smart-sheets-user";

const USERS = [
	{ username: "Nicholas", password: "Ottoisthebest2025!!" },
	{ username: "Erin", password: "Ottoisthebest2026!" }, //Ottoisthebest2025!
];

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(() => {
		try {
			return localStorage.getItem(STORAGE_KEY) || null;
		} catch {
			return null;
		}
	});

	const login = useCallback((password) => {
		const match = USERS.find((u) => u.password === password);
		if (match) {
			setUser(match.username);
			localStorage.setItem(STORAGE_KEY, match.username);
			return true;
		}
		return false;
	}, []);

	const logout = useCallback(() => {
		setUser(null);
		localStorage.removeItem(STORAGE_KEY);
	}, []);

	return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error("useAuth must be used within an AuthProvider");
	}
	return context;
};

export const RequireAuth = ({ children }) => {
	const { user } = useAuth();
	if (!user) return <Navigate to="/login" replace />;
	return children;
};

export default AuthContext;
